module.exports = __webpack_public_path__ + "static/img/title2.d884cb59.png";